/* eslint-disable no-unused-vars */
export enum LicenseClassType {
  B = 'B',
  TWO = '2',
  THREE = '3',
  OTHER = 'Andere',
}

export enum OauthProviders {
  VW = 'Volkswagen ID',
  AUDI = 'Audi ID',
}

// Enum key is <FrontendBrand_AuthorizationProvider>.
// Enum value is defined by Id Broker
export enum OauthProvidersHint {
  AUDI_VW = 'idkrentdeaudiaudi',
  VWFS_VW = 'idkrentdevwfs',
}

export enum OauthClientId {
  AUDI = 'custPortalClientAudi',
  VWFS = 'custPortalClientVwfs',
}

export enum Brand {
  AUDI = 'audi',
  VWFS = 'vwfs',
}

export enum LastFormSectionCompleted {
  PERSONAL = 'PERSONAL',
  CONTACT = 'CONTACT',
  DRIVERS = 'DRIVERS',
  PAYMENT = 'PAYMENT',
}

export enum TransactionStatus {
  INITIALIZED = 'INITIALIZED',
  APPLICATIONFORM_STARTED = 'APPLICATIONFORM_STARTED',
}

export enum ARTICLE {
  /* einen - masculine when in accusative case */
  /* ein - masculine and neuter in nominative case */
  /* eine - feminine in nominative and accusative case */
  EINEN = 'einen',
  EIN = 'ein',
  EINE = 'eine',
}

export const CUSTOM_VALIDATION_ERRORS = {
  valueInvalid: (fieldValue: string, article: ARTICLE) => {
    const needsN = ["Vorname", "Nachname"].includes(fieldValue);
    const needsS = fieldValue === "Geburtsdatum";
    const needsEn = fieldValue === "Ort";

    // eslint-disable-next-line no-nested-ternary
    return `Bitte geben Sie ${needsEn ? "einen" : article} gültige${needsN ? "n" : ""}${needsS ? "s" : needsEn ? "n" : ""} ${fieldValue}${needsN ? "n" : ""} an.`;
  }
};
